export default __webpack_public_path__ + "static/media/logo-full-white.a4c4a010.svg";